import { STRICT_US_STATES, STRICT_US_STATES_CODES } from "./fetch-geo-data";

export const isStrictUSStateByCode = (code: string) => {
  return STRICT_US_STATES_CODES.includes(code);
};

export const isStrictUSStateByName = (name: string) => {
  return STRICT_US_STATES.includes(name);
};
